<div class="h-full flex flex-col">
  <div class="bg-white p-4 m-auto w-full h-full max-lg:px-3">
    <div class="max-w-content m-auto">
      <div class="max-w-header flex m-auto">
        <a [routerLink]="['/']">
          <img
            class="logo h-14 transform transition duration-500 hover:scale-110"
            src="assets/images/bolt-logo-nw-horizontal-full.svg"
            alt="logo-nw"
            width="191px"
            height="56px"
          />
        </a>

        @if (!isMobile) {
          <div class="pr-3 flex ml-auto my-auto text-vibrantBlue leading-loose">
            <div>{{ displayName$ | async }}</div>

            <div class="rounded-full w-7 h-7 ml-2 text-center flex-none bg-gray-300">
              <span nz-icon nzType="user" nzTheme="outline"></span>
            </div>
          </div>
        } @else {
          <div class="flex ml-auto my-auto">
            @if (changeIcon) {
              <bolt-icon name="xmark" (click)="toggleNavMenu()" (keydown.enter)="toggleNavMenu()"></bolt-icon>
            } @else {
              <bolt-icon name="menu" (click)="toggleNavMenu()" (keydown.enter)="toggleNavMenu()"></bolt-icon>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
